import React,{Component, useState, useEffect} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner';
import Select from 'react-select';
import axiosService from '../../helpers/axios';

import { saveAs } from 'file-saver';

  export default class InputsCostsGridTransferts extends Component{ 

    constructor(props){
      super(props);

      this.state={
          costgridtransferts:[],
          modalTitle:"",
          recordtfid:0,
          from_warehouseid: 0,
          to_warehouseid: 0,
          yearid: 0,
          lotid: 0,
          subtaskid: 0,
          uomid: 0,
          currencyid:0,
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",

          from_warehouse: {
			warehouseid: 0,
			warehousename: "",
			countryid: 0
		},
		to_warehouse: {
			warehouseid: 0,
			warehousename: "",
			countryid: 0
		},

          from_warehouseCountryRegion: {
			fwarehouseid: 0,
			warehousename: "",
			warehousecountry: {
				regionid: 0,
				region: {
					regionname: "",
					regionid:0
				}
			}
		},

        to_warehouseCountryRegion: {
			warehouseid: 0,
			warehousename: "",
			warehousecountry: {
				regionid: 0,
				region: {
					regionname: "",
					regionid:0
				}
			}
		},

		year: {
			yearid:0,
			fyname:"",
			isactive: true
		},
		lot: {
			costgridlotid: 0,
			costgridlotname:""
		},
		subtask: {
			costgridsubtaskid: 0,
			costgridsubtaskname: ""
		},
		uom: {
			uomid: 0,
			uomname: ""
		},

        currency: {
			currencyid:0,
			devise: "",
			devisename: ""
		},
          
          FromWarehouseNameFilter:"",
          ToWarehouseNameFilter:"",
          FiscalYearFilter:"",
          CostGridLotNameFilter:"",
          CostGridSubTaskNameFilter:"",
          CostGridUomNameFilter:"",
          RecordTfIdFilter:"",
          costgridtransfertsWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          cosgridlotNames: [],
          cosgridsubtaskNames: [],
          cosgriduomNames: [],
          deviseNames: [],
          warehouseNames: [],
          toWarehouseNames: [],
          loading: true,
          isEditClicked: false,


          
          recordfilterid:0,
          lotnamefilter: "",
          lotidfilter: 0,
          subtasknamefilter: "",
          subtaskidfilter: 0,
          uomnamefilter: "",
          uomidfilter: 0,
          lotsfilter: [],
          subtasksfilter: [],
          uomsfilter: [],
          selectedLot: '',
          selectedSubTask: '',
          selectedUOM: '',


          costgridtransfertsfilter : [],

          //subtasks_additional_fees : [],
          subtasks_customs_duties : [],
          subtasks_destination_charges :[],
          subtasks_freight : [],
          //subtasks_kitting_vas : [],
          //subtasks_last_mile_delivery : [],
          //subtasks_origin_charges : [],
          //subtasks_return_flow: [],
          subtasks_warehousing : [],
          subtasks_vat : [],

          //per_migration_item : [],
          //monthly_value :[],
          goods_value : [],
          //per_container :[],
          //per_pallet : [],
          //per_kit :[],
          //per_item : [],
          //applied_cost_per_truck : [],
          //per_unit_pair : [],
          //uom_origin_charges :[],
          //uom_container_inbound : [],
          //uom_cost_per_truck : [],
          per_unit:[],


          uniqueFiscalYears:[],
          uniqueRowConcat:[],

          uniqueFromWarehouses :[],
          uniqueToWarehouses :[],
          uniqueCountries:[],
          uniqueCurrencies:[],
          uniqueLots:[],
          uniqueSubtasks:[],
          uniqueUoms:[],

          
          file: null,
          message: '',
          errors: []

          
      };

      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleUpload = this.handleUpload.bind(this);
      this.downloadCSV = this.downloadCSV.bind(this);
      this.refreshList = this.refreshList.bind(this);
  }


  
  handleUpload = async () => {
    const { file } = this.state;
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }
  
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await axiosService.post('/costgrid_transfertupload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      const data = response.data?.results ?? response.data;
      this.setState({ message: 'File uploaded successfully.', errors: [] });
      alert('File uploaded successfully.');
      window.location.reload();
  
    } catch (error) {
      let errorMessage = 'Upload failed';
      
      if (error.response?.data?.errors && error.response.data.errors.length > 0) {
        const errorList = error.response.data.errors.map(err => `Row ${err.row}: ${err.error}`).join('\n');
        errorMessage += `\n\nErrors:\n${errorList}`;
      }
      
      this.setState({ message: errorMessage, errors: [] });
      alert(errorMessage);
      window.location.reload();
      window.location.reload();
    }
  };
  


  handleFileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };


  
  downloadCSV() {
    const { costgridtransferts } = this.state;
    const headers = [
      'fiscalyear',
      'from_warehouse',
      'to_warehouse',
      'lotid',
      'lot',
      'subtaskid',
      'subtask',
      'uomid',
      'uom',
      'devise',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
    ];

    const escapeCSVField = (field) => {
      if (field == null) {
        return 'N/A';
      }
      if (typeof field === 'string') {
        return `"${field.replace(/"/g, '""')}"`; // Escape double quotes by doubling them
      }
      return field;
    };


    const rows = costgridtransferts.map(dep => [
      escapeCSVField(dep.year?.fyname),
      escapeCSVField(dep.from_warehouse?.warehousename),
      escapeCSVField(dep.to_warehouse?.warehousename),
      escapeCSVField(dep.lot?.costgridlotid),
      escapeCSVField(dep.lot?.costgridlotname),
      escapeCSVField(dep.subtask?.costgridsubtaskid),
      escapeCSVField(dep.subtask?.costgridsubtaskname),
      escapeCSVField(dep.uom?.uomid),
      escapeCSVField(dep.uom?.uomname),
      escapeCSVField(dep.currency?.devise ),
      escapeCSVField(dep.july),
      escapeCSVField(dep.august),
      escapeCSVField(dep.september),
      escapeCSVField(dep.october),
      escapeCSVField(dep.november),
      escapeCSVField(dep.december),
      escapeCSVField(dep.january),
      escapeCSVField(dep.february),
      escapeCSVField(dep.march),
      escapeCSVField(dep.april),
      escapeCSVField(dep.may),
      escapeCSVField(dep.june)

    ]);

    let csvContent = '';
    csvContent += headers.join(';') + '\r\n';
    rows.forEach(rowArray => {
      const row = rowArray.join(';');
      csvContent += row + '\r\n';
    });

    const today = new Date();

    const formattedDate = today.toISOString().slice(0, 10); // Format today's date as YYYY-MM-DD

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], {
      type: 'text/csv;charset=utf-8'
  });
    saveAs(blob, `costgrid_transferts_${formattedDate}.csv`);
  }


  FilterFn(){
    var FromWarehouseNameFilter = this.state.FromWarehouseNameFilter;
    var ToWarehouseNameFilter = this.state.ToWarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var CostGridLotNameFilter = this.state.CostGridLotNameFilter;
    var CostGridSubTaskNameFilter = this.state.CostGridSubTaskNameFilter;
    var CostGridUomNameFilter = this.state.CostGridUomNameFilter;
    var RecordTfIdFilter = this.state.RecordTfIdFilter;

    var filteredData=this.state.costgridtransfertsWithoutFilter.filter(
        function(el){
            return el.from_warehouse?.warehousename.toString().toLowerCase().includes(
                FromWarehouseNameFilter.toString().trim().toLowerCase()
            )&&  el.to_warehouse?.warehousename.toString().toLowerCase().includes(
                ToWarehouseNameFilter.toString().trim().toLowerCase()
            )&&
                el.year?.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.lot?.costgridlotname.toString().toLowerCase().includes(
                CostGridLotNameFilter.toString().trim().toLowerCase()
            )&&  
                el.subtask?.costgridsubtaskname.toString().toLowerCase().includes(
                CostGridSubTaskNameFilter.toString().trim().toLowerCase()
            )&&  
                el.uom?.uomname.toString().toLowerCase().includes(
                CostGridUomNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({costgridtransferts:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.costgridtransfertsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({costgridtransferts:sortedData});

}



changeFromWarehouseNameFilter = (e)=>{
    this.state.FromWarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

  changeToWarehouseNameFilter = (e)=>{
    this.state.ToWarehouseNameFilter=e.target.value;
    this.FilterFn();
  }


changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeCostGridLotNameFilter = (e)=>{
    this.state.CostGridLotNameFilter=e.target.value;
    this.FilterFn();
  }

  changeCostGridSubTaskNameFilter = (e)=>{
    this.state.CostGridSubTaskNameFilter=e.target.value;
    this.FilterFn();
  }

  changeCostGridUomNameFilter = (e)=>{
    this.state.CostGridUomNameFilter=e.target.value;
    this.FilterFn();
  }


changeRecordTfIdFilter = (e)=>{
    this.state.RecordTfIdFilter=e.target.value;
    this.FilterFn();
  }



refreshList = () => {
    axiosService.get('/costgridtransferts/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ costgridtransferts: data, costgridtransfertsWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };



  refreshList2 = () => {
    axiosService.get('/costgridfilter/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ costgridfilter: data, costgridWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };



fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchCostGridLotNames() {
    axiosService.get('/costgridlots/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const cosgridlotNames = data.map(item => item.costgridlotname);
        this.setState({ cosgridlotNames: cosgridlotNames });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }


  fetchCostGridSubTaskNames() {
    axiosService.get('/costgridsubtasks/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const cosgridsubtaskNames = data.map(item => item.costgridsubtaskname);
        this.setState({ cosgridsubtaskNames: cosgridsubtaskNames });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchCostGridUomNames() {
    axiosService.get('/costgriduoms/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const cosgriduomNames = data.map(item => item.uomname);
        this.setState({ cosgriduomNames: cosgriduomNames });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }


  fetchDeviseNames() {
    axiosService.get('/currencies/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const deviseNames = data.map(item => item.devisename);
        this.setState({ deviseNames: deviseNames });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

  fetchToWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const toWarehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ toWarehouseNames: toWarehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }


handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };



    fetchLotsCostGridFilter() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.lotnamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ lotsfilter: result });
        })
        .catch(error => {
          console.error("Error fetching lotnames:", error);
        });
    }

    fetchSubtasksCostGridFilter() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.subtasknamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasksfilter: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }

  
    fetchUomsCostGridFilter() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.uomnamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uomsfilter: result });
        })
        .catch(error => {
          console.error("Error fetching uomnames:", error);
        });
    }

    fetchUniqueFiscalYearsCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.year.fyname))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueFiscalYears: result });
        })
        .catch(error => {
          console.error("Error fetching years:", error);
        });
    }
    

    fetchUniqueRowConcat() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => `${item.year.fyname}${item.from_warehouse.warehousename}${item.to_warehouse.warehousename}${item.lot.costgridlotname}${item.subtask.costgridsubtaskname}${item.uom.uomname}`)));
          this.setState({ uniqueRowConcat: result });
        })
        .catch(error => {
          console.error("Error fetching concatList:", error);
        });
    }
    
    fetchUniqueFromWarehousesCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.from_warehouse.warehousename))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueFromWarehouses: result });
        })
        .catch(error => {
          console.error("Error fetching from_warehouses:", error);
        });
    }

    fetchUniqueToWarehousesCostGrid() {
        axiosService.get('/costgridtransferts/')
          .then(response => {
            const data = response.data?.results ?? response.data;
            const result = Array.from(new Set(data.map(item => item.to_warehouse.warehousename))); // Assuming you want to append 'subtaskname' to the property
            this.setState({ uniqueToWarehouses: result });
          })
          .catch(error => {
            console.error("Error fetching to_warehouses:", error);
          });
      }


    fetchUniqueCurrenciesCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.currency.devisename))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueCurrencies: result });
        })
        .catch(error => {
          console.error("Error fetching currencies:", error);
        });
    }


    fetchUniqueLotsCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.lot.costgridlotname))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueLots: result });
        })
        .catch(error => {
          console.error("Error fetching lots:", error);
        });
    }
  
    fetchUniqueSubtasksCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.subtask.costgridsubtaskname))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueSubtasks: result });
        })
        .catch(error => {
          console.error("Error fetching subtasks:", error);
        });
    }

    fetchUniqueUomsCostGrid() {
      axiosService.get('/costgridtransferts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const result = Array.from(new Set(data.map(item => item.uom.uomname))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ uniqueUoms: result });
        })
        .catch(error => {
          console.error("Error fetching uoms:", error);
        });
    }





    fetchSubtasksCUSTOMSDUTIES() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.lotnamefilter === "CUSTOMS, DUTIES");
          const result =Array.from(new Set(filteredData.map(item => item.subtasknamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasks_customs_duties: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }

fetchSubtasksDESTINATIONCHARGES() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.lotnamefilter === "DESTINATION CHARGES");
          const result = Array.from(new Set(filteredData.map(item => item.subtasknamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasks_destination_charges: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }

    fetchSubtasksFREIGHT() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.lotnamefilter === "FREIGHT");
          const result = Array.from(new Set(filteredData.map(item => item.subtasknamefilter)));// Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasks_freight: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }




    fetchSubtasksWAREHOUSING() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.lotnamefilter === "WAREHOUSING");
          const result = Array.from(new Set(filteredData.map(item => item.subtasknamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasks_warehousing: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }

    fetchSubtasksVAT() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.lotnamefilter === "VAT");
          const result = Array.from(new Set(filteredData.map(item => item.subtasknamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ subtasks_vat: result });
        })
        .catch(error => {
          console.error("Error fetching subtasknames:", error);
        });
    }
    

    fetchUOMPERUNIT() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.uomnamefilter === "per unit");
          const result = Array.from(new Set(filteredData.map(item => item.uomnamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ per_unit: result });
        })
        .catch(error => {
          console.error("Error fetching lotnames:", error);
        });
    }
    

    fetchUOMGOODSVALUE() {
      axiosService.get('/costgridtransfertsfilter/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.uomnamefilter === "goods % value");
          const result = Array.from(new Set(filteredData.map(item => item.uomnamefilter))); // Assuming you want to append 'subtaskname' to the property
          this.setState({ goods_value: result });
        })
        .catch(error => {
          console.error("Error fetching lotnames:", error);
        });
    } 






componentDidMount(){
  this.refreshList();

  this.fetchUniqueFiscalYearsCostGrid();
  this.fetchUniqueFromWarehousesCostGrid();
  this.fetchUniqueToWarehousesCostGrid();
  this.fetchUniqueCurrenciesCostGrid();
  this.fetchUniqueLotsCostGrid();
  this.fetchUniqueSubtasksCostGrid();
  this.fetchUniqueUomsCostGrid();

  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchFiscalYears();
  this.fetchCostGridLotNames();
  this.fetchWarehouseNames();
  this.fetchToWarehouseNames();
  this.fetchCostGridLotNames();
  this.fetchCostGridSubTaskNames();
  this.fetchCostGridUomNames();
  this.fetchDeviseNames();

  this.fetchLotsCostGridFilter();
  this.fetchSubtasksCostGridFilter();
  this.fetchUomsCostGridFilter();

 
  this.fetchSubtasksCUSTOMSDUTIES();
  this.fetchSubtasksDESTINATIONCHARGES();
  this.fetchSubtasksFREIGHT();
  this.fetchSubtasksWAREHOUSING();
  this.fetchSubtasksVAT();



  this.fetchUOMPERUNIT();
  this.fetchUOMGOODSVALUE();
  this.fetchUniqueRowConcat();
  
}


handleLotChange = (event) => {
  const selectedLot = event.target.value;
  this.setState({
    selectedLot,
    selectedSubTask: '',
    selectedUOM: '',
  });
};

handleSubTaskChange = (event) => {
  const selectedSubTask = event.target.value;
  this.setState({
    selectedSubTask,
    selectedUOM: '',
  });
};

handleUOMChange = (event) => {
  const selectedUOM = event.target.value;
  this.setState({
    selectedUOM,
  });
};



changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}


changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeCostGridLotName =(e)=>{
    this.setState({costgridlotname:e.target.value});
  }

changeCostGridSubTaskName =(e)=>{
    this.setState({costgridsubtaskname:e.target.value});
  }

changeCostGridUomName =(e)=>{
    this.setState({uomname:e.target.value});
  }

changeDeviseName =(e)=>{
    this.setState({devisename:e.target.value});
  }

changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }

addClick(){
  this.setState({
      modalTitle:"Add CostGridTransferts",
      recordtfid:0,
      from_warehousename:"",
      to_warehousename:"",
      fyname:"",
      costgridlotname:"",
      costgridsubtaskname:"",
      uomname:"",
      devisename:"",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      isEditClicked: false,
  });
}


editClick(dep) {
  // Check if devisename is empty, and if so, set it to "N/A"
  const updatedDevisename = dep.currency.devisename || 'none';

  this.setState({
    modalTitle: "Edit CostGridTransferts",
    recordtfid: dep.recordtfid,
    from_warehousename: dep.from_warehouse.warehousename,
    to_warehousename: dep.to_warehouse.warehousename,
    fyname: dep.year.fyname,
    costgridlotname: dep.lot.costgridlotname,
    costgridsubtaskname: dep.subtask.costgridsubtaskname,
    uomname: dep.uom.uomname,
    devisename: updatedDevisename, // Updated devisename value
    july: dep.july,
    august: dep.august,
    september: dep.september,
    october: dep.october,
    november: dep.november,
    december: dep.december,
    january: dep.january,
    february: dep.february,
    march: dep.march,
    april: dep.april,
    may: dep.may,
    june: dep.june,
    initialFromWarehousename: dep.from_warehouse.warehousename,
    initialToWarehousename: dep.to_warehouse.warehousename,
    initialFyname: dep.year.fyname,
    initialCostgridlotname: dep.lot.costgridlotname,
    initialCostgridsubtaskname: dep.subtask.costgridsubtaskname,
    initialCostgriduomname: dep.uom.uomname,
    initialDevisename: updatedDevisename, // Updated initialDevisename value
    initialJuly: dep.july,
    initialAugust: dep.august,
    initialSeptember: dep.september,
    initialOctober: dep.october,
    initialNovember: dep.november,
    initialDecember: dep.december,
    initialJanuary: dep.january,
    initialFebruary: dep.february,
    initialMarch: dep.march,
    initialApril: dep.april,
    initialMay: dep.may,
    initialJune: dep.june,
    isEditClicked: true,
  });
}


createClick() {
  const {  from_warehousename, to_warehousename, fyname, costgridlotname, costgridsubtaskname,uomname, devisename, july, august, september, october,
  november, december, january, february, march, april, may, june, uniqueFiscalYears, uniqueCountries, uniqueCurrencies, uniqueFromWarehouses, 
  uniqueToWarehouses, uniqueLots, uniqueSubtasks,
uniqueUoms,uniqueRowConcat } = this.state;


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!from_warehousename) {
    alert('From_Warehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('To_Warehouse is required');
    return;
  }

  if (!costgridlotname) {
    alert('CostGridLot is required');
    return;
  }

  if (!costgridsubtaskname) {
    alert('CostGridSubTask is required');
    return;
  }

  if (!uomname) {
    alert('CostGridUOM is required');
    return;
  }

  if (!devisename) {
    alert('DeviseName is required, set to none ');
    return;
  }



  if (uniqueRowConcat.includes(`${fyname}${from_warehousename}${to_warehousename}${costgridlotname}${costgridsubtaskname}${uomname}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
}


  axiosService.post('/costgridtransfertscreate/', {
    from_warehousename: from_warehousename,
    to_warehousename: to_warehousename,
    fyname: fyname,
    costgridlotname:costgridlotname,
    costgridsubtaskname:costgridsubtaskname,
    uomname:uomname,
    devisename:devisename,
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june
  })
    .then(result => {
      alert('CostGridTransferts created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { from_warehousename, to_warehousename, fyname, costgridlotname, costgridsubtaskname, uomname,devisename, july, august, september, october,
    november, december, january, february, march, april, may, june, initialCountryname,
    initialFromWarehousename, initialToWarehousename,initialFyname, initialCostgridlotname,initialCostgridsubtaskname,initialCostgriduomname, initialDevisename, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune  } = this.state;

  if (
    from_warehousename === initialFromWarehousename&&
    to_warehousename === initialToWarehousename&&
    fyname === initialFyname &&
    costgridlotname === initialCostgridlotname &&
    costgridsubtaskname === initialCostgridsubtaskname &&
    uomname === initialCostgriduomname &&
    devisename === initialDevisename &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune
  ) {
    alert('No changes detected');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!from_warehousename) {
    alert('From Warehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('To Warehouse is required');
    return;
  }



  if (!costgridlotname) {
    alert('CostGridLot is required');
    return;
  }

  if (!costgridsubtaskname) {
    alert('CostGridSubTask is required');
    return;
  }

  if (!uomname) {
    alert('CostGridUOM is required');
    return;
  }

  if (!devisename) {
    alert('DeviseName is required, set to none ');
    return;
  }


  
  axiosService.patch('/costgridtransferts/' + id + '/', {
    from_warehousename: this.state.from_warehousename,
    to_warehousename: this.state.to_warehousename,
    fyname: this.state.fyname,
    costgridlotname : this.state.costgridlotname,
    costgridsubtaskname : this.state.costgridsubtaskname,
    uomname : this.state.uomname,
    devisename : this.state.devisename,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}



copyClick() {
  const { from_warehousename,to_warehousename, fyname, costgridlotname, costgridsubtaskname, uomname,devisename, july, august, september, october,
    november, december, january, february, march, april, may, june, initialCountryname,
    initialWarehousename, initialFyname, initialCostgridlotname,initialCostgridsubtaskname,initialCostgriduomname, initialDevisename, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune ,
    uniqueFiscalYears, uniqueCountries, uniqueCurrencies, uniqueFromWarehouses,uniqueToWarehouses, uniqueLots, uniqueSubtasks,
    uniqueUoms, uniqueRowConcat } = this.state;



  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!from_warehousename) {
    alert('From Warehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('to Warehouse is required');
    return;
  }


  if (!costgridlotname) {
    alert('CostGridLot is required');
    return;
  }

  if (!costgridsubtaskname) {
    alert('CostGridSubTask is required');
    return;
  }

  if (!uomname) {
    alert('CostGridUOM is required');
    return;
  }

  if (!devisename) {
    alert('DeviseName is required, set to none ');
    return;
  }



  if (uniqueRowConcat.includes(`${fyname}${from_warehousename}${to_warehousename}${costgridlotname}${costgridsubtaskname}${uomname}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
}

  axiosService.post('/costgridtransfertscreate/', {
    from_warehousename: this.state.from_warehousename,
    to_warehousename: this.state.to_warehousename,
    fyname: this.state.fyname,
    costgridlotname : this.state.costgridlotname,
    costgridsubtaskname : this.state.costgridsubtaskname,
    uomname : this.state.uomname,
    devisename : this.state.devisename,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('CostGridTransferts created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/costgridtransferts/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      costgridtransferts,
      modalTitle,
      recordtfid,
      from_warehousename,
      to_warehousename,
      regionname,
      fyname,
      costgridlotname,
      costgridsubtaskname,
      uomname,
      devisename,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,

      lotsfilter, subtasksfilter, uomsfilter, selectedLot, selectedSubTask, selectedUOM, lotnamefilter, lotidfilter, subtasknamefilter, subtaskidfilter,uomnamefilter, uomidfilter

  }=this.state;

  //const filteredSubTasks = subtasksfilter.filter((subtasknamefilter) => subtasknamefilter.lotidfilter === parseInt(selectedLot));
   // const filteredUOMs = uomsfilter.filter((uomnamefilter) => uomnamefilter.subtaskidfilter === parseInt(selectedSubTask));

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsInputs />


<button  type="button"
className="btn btn-primary m-2 float-end"
onClick={this.downloadCSV}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Download

</button>


<div className="d-flex flex-row align-items-center">
    <input 
    disabled={!isSuperAdmin()}
    className="form-control m-2" 
    type="file" 
    style={{ width: "200px", height:"30px", fontSize: "12px" }}
    onChange={this.handleFileChange} />
    <button type="button"
    disabled={!isSuperAdmin()}
    className="btn btn-primary m-2 float-end"
    style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
    onClick={this.handleUpload}>Upload File</button>
     
</div>


<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr  className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFromWarehouseNameFilter}
      placeholder="Filter"/>

      </div>
      From Warehouse
  </th>
  

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeToWarehouseNameFilter}
      placeholder="Filter"/>

      </div>
      To Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridLotNameFilter}
      placeholder="Filter"/>


      </div>
      Lot
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridSubTaskNameFilter}
      placeholder="Filter"/>

      </div>
      SubTask
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridUomNameFilter}
      placeholder="Filter"/>

      </div>
      UOM
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Currency
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {costgridtransferts.map(dep=>
      <tr key={dep.recordtfid} className="row-hover">
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.from_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.to_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.lot?.costgridlotname ?? 'N/A'}</td>
          <td className="table-text">{dep.subtask?.costgridsubtaskname ?? 'N/A'}</td>
          <td className="table-text">{dep.uom?.uomname ?? 'N/A'}</td>
          <td className="table-text">{dep.currency?.devisename ?? 'N/A'}</td>
          <td className="table-text">{dep.july ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.july) : 'N/A'}</td>
<td className="table-text">{dep.august ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.august) : 'N/A'}</td>
<td className="table-text">{dep.september ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.september) : 'N/A'}</td>
<td className="table-text">{dep.october ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.october) : 'N/A'}</td>
<td className="table-text">{dep.november ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.november) : 'N/A'}</td>
<td className="table-text">{dep.december ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.december) : 'N/A'}</td>
<td className="table-text">{dep.january ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.january) : 'N/A'}</td>
<td className="table-text">{dep.february ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.february) : 'N/A'}</td>
<td className="table-text">{dep.march ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.march) : 'N/A'}</td>
<td className="table-text">{dep.april ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.april) : 'N/A'}</td>
<td className="table-text">{dep.may ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.may) : 'N/A'}</td>
<td className="table-text">{dep.june ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.june) : 'N/A'}</td>

          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.recordtfid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>


          
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>



        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >From Warehouse</span>
          <select
            className="form-select"
            value={this.state.from_warehousename}
            onChange={(event) => this.setState({ from_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select from_warehouse</option>
            {this.state.warehouseNames.filter((warehouse) => warehouse !== this.state.to_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >To Warehouse</span>
          <select
            className="form-select"
            value={this.state.to_warehousename}
            onChange={(event) => this.setState({ to_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select to_warehouse</option>
            {this.state.toWarehouseNames.filter((warehouse) => warehouse !== this.state.from_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Lot</span>
          <select
            className="form-select"
            value={this.state.costgridlotname}
            onChange={(event) => this.setState({ costgridlotname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a lot</option>
            {this.state.lotsfilter.map((lot) => (
              <option key={lot} value={lot}>
                {lot}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>SubTask</span>
  <select
    className="form-select"
    value={this.state.costgridsubtaskname}
    onChange={(event) => this.setState({ costgridsubtaskname: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select a subtask</option>
    {this.state.costgridlotname === "CUSTOMS, DUTIES" ? (
      // If lotname is "Condition2", use a different array
      this.state.subtasks_customs_duties.map((subtask) => (
        <option key={subtask} value={subtask}>
          {subtask}
        </option>
      ))
      ) : this.state.costgridlotname === "DESTINATION CHARGES" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_destination_charges.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

      ) : this.state.costgridlotname === "FREIGHT" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_freight.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

      ) : this.state.costgridlotname === "WAREHOUSING" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_warehousing.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

        ) : this.state.costgridlotname === "VAT" ? (
          // If lotname is "Condition2", use a different array
          this.state.subtasks_vat.map((subtask) => (
            <option key={subtask} value={subtask}>
              {subtask}
            </option>
          ))

        ) : (
      // If lotname is not "ER", use uoms
      this.state.cosgridsubtaskNames.map((subtask) => (
        <option key={subtask} value={subtask}>
          {subtask}
        </option>
      ))
    )}
  </select>
</div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>UOM</span>
  <select
    className="form-select"
    value={this.state.uomname}
    onChange={(event) => this.setState({ uomname: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select uom</option>
    {((this.state.costgridlotname === "CUSTOMS, DUTIES" && this.state.costgridsubtaskname === "Customs & Duties") ||
      (this.state.costgridlotname === "VAT" && this.state.costgridsubtaskname === "VAT ")) ? (
        // If lotname is "Condition2", use a different array
        this.state.goods_value.map((uom) => (
          <option key={uom} value={uom}>
            {uom}
          </option>
        ))

      ) : ((this.state.costgridlotname === "DESTINATION CHARGES" && this.state.costgridsubtaskname === "THC Handling & delivery to WH") ||
      (this.state.costgridlotname === "FREIGHT" && this.state.costgridsubtaskname === "Transport charges") ||
      (this.state.costgridlotname === "WAREHOUSING" && this.state.costgridsubtaskname === "Container inbound")  ) ? (
        // If lotname is "Condition2", use a different array
        this.state.per_unit.map((uom) => (
          <option key={uom} value={uom}>
            {uom}
          </option>
        ))

      ): (
      // If lotname is not "ER", use uoms
      this.state.uomsfilter.map((uom) => (
        <option key={uom} value={uom}>
          {uom}
        </option>
      ))
    )}
  </select>
</div>



        



        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Currency</span>
          <select
            className="form-select"
            value={this.state.devisename}
            onChange={(event) => this.setState({ devisename: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a devise</option>
            {this.state.deviseNames.map((devise) => (
              <option key={devise} value={devise}>
                {devise}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
         
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>


        {recordtfid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {recordtfid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(recordtfid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>



        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >From Warehouse</span>
          <select
            className="form-select"
            value={this.state.from_warehousename}
            onChange={(event) => this.setState({ from_warehousename: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select from_warehouse</option>
            {this.state.warehouseNames.filter((warehouse) => warehouse !== this.state.to_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >To Warehouse</span>
          <select
            className="form-select"
            value={this.state.to_warehousename}
            onChange={(event) => this.setState({ to_warehousename: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select to_warehouse</option>
            {this.state.toWarehouseNames.filter((warehouse) => warehouse !== this.state.from_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Lot</span>
          <select
            className="form-select"
            value={this.state.costgridlotname}
            onChange={(event) => this.setState({ costgridlotname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a lot</option>
            {this.state.lotsfilter.map((lot) => (
              <option key={lot} value={lot}>
                {lot}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>SubTask</span>
  <select
    className="form-select"
    value={this.state.costgridsubtaskname}
    onChange={(event) => this.setState({ costgridsubtaskname: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select a subtask</option>
    {this.state.costgridlotname === "CUSTOMS, DUTIES" ? (
      // If lotname is "Condition2", use a different array
      this.state.subtasks_customs_duties.map((subtask) => (
        <option key={subtask} value={subtask}>
          {subtask}
        </option>
      ))
      ) : this.state.costgridlotname === "DESTINATION CHARGES" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_destination_charges.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

      ) : this.state.costgridlotname === "FREIGHT" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_freight.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

      ) : this.state.costgridlotname === "WAREHOUSING" ? (
        // If lotname is "Condition2", use a different array
        this.state.subtasks_warehousing.map((subtask) => (
          <option key={subtask} value={subtask}>
            {subtask}
          </option>
        ))

        ) : this.state.costgridlotname === "VAT" ? (
          // If lotname is "Condition2", use a different array
          this.state.subtasks_vat.map((subtask) => (
            <option key={subtask} value={subtask}>
              {subtask}
            </option>
          ))

        ) : (
      // If lotname is not "ER", use uoms
      this.state.cosgridsubtaskNames.map((subtask) => (
        <option key={subtask} value={subtask}>
          {subtask}
        </option>
      ))
    )}
  </select>
</div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>UOM</span>
  <select
    className="form-select"
    value={this.state.uomname}
    onChange={(event) => this.setState({ uomname: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select uom</option>
    {((this.state.costgridlotname === "CUSTOMS, DUTIES" && this.state.costgridsubtaskname === "Customs & Duties") ||
      (this.state.costgridlotname === "VAT" && this.state.costgridsubtaskname === "VAT ")) ? (
        // If lotname is "Condition2", use a different array
        this.state.goods_value.map((uom) => (
          <option key={uom} value={uom}>
            {uom}
          </option>
        ))

      ) : ((this.state.costgridlotname === "DESTINATION CHARGES" && this.state.costgridsubtaskname === "THC Handling & delivery to WH") ||
      (this.state.costgridlotname === "FREIGHT" && this.state.costgridsubtaskname === "Transport charges") ||
      (this.state.costgridlotname === "WAREHOUSING" && this.state.costgridsubtaskname === "Container inbound")  ) ? (
        // If lotname is "Condition2", use a different array
        this.state.per_unit.map((uom) => (
          <option key={uom} value={uom}>
            {uom}
          </option>
        ))

      ): (
      // If lotname is not "ER", use uoms
      this.state.uomsfilter.map((uom) => (
        <option key={uom} value={uom}>
          {uom}
        </option>
      ))
    )}
  </select>
</div>



        



        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Currency</span>
          <select
            className="form-select"
            value={this.state.devisename}
            onChange={(event) => this.setState({ devisename: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a devise</option>
            {this.state.deviseNames.map((devise) => (
              <option key={devise} value={devise}>
                {devise}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
         
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }} 
          />

        </div>


        {recordtfid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {recordtfid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

</div>
  )
}
  }




